import React from 'react';
import { Route } from 'react-router-dom';
import { deepLinks } from './deepLinks';
import DeepLinkGate from './DeepLinkGate';

/**
 * Rutas de deep link para un Switch de react-router.
 * Deben ser hijos directos de Switch (no envolverlas en otro componente).
 * Se incluyen links cuya URL pública o cuyo destino pertenecen al prefijo
 * (así /load/:loadId entra en el layout de /carrier).
 */
const matchesPrefix = (path, pathPrefix) =>
  path === pathPrefix || path.startsWith(`${pathPrefix}/`);

const belongsToPrefix = (definition, pathPrefix) =>
  matchesPrefix(definition.path, pathPrefix) ||
  matchesPrefix(definition.targetPath, pathPrefix);

const getDeepLinkRoutes = (pathPrefix = '') =>
  deepLinks
    .filter(definition => !pathPrefix || belongsToPrefix(definition, pathPrefix))
    .map(definition => (
      <Route
        exact
        key={definition.path}
        path={definition.path}
        render={() => <DeepLinkGate definition={definition} />}
      />
    ));

export default getDeepLinkRoutes;
